<div class="task-closed rounded px-1">
  <div><strong>Task Closed</strong></div>
  <div>
    @if (task.allCapturesHaveConsultNote) {
      <p>A valid consult note has been collected for this patient.</p>
    }
    @if (!task.allCapturesHaveConsultNote) {
      <p>No consult note has been collected for this patient.</p>
    }
  </div>
</div>
